import { Product, ZakelijkProduct } from "shared/api/middleware-api-client";
import Heading from "shared/ui/typography/Heading";
import Text from "shared/ui/typography/Text";

interface ProductItemConfigTableProps {
  product: Product | ZakelijkProduct;
  className?: string;
}

const ProfielProductItemConfigTable = ({
  product,
  className = "",
}: ProductItemConfigTableProps) => {
  // Layout name
  const doorLayoutName = product.doorLayout.name;
  const doorLayoutPrice = "€" + (product.doorLayout.price ?? 0).toFixed(2);
  // Color name
  const doorColorName = product.doorColor.name;
  const doorColorPrice = "€" + (product.doorColor.price ?? 0).toFixed(2);

  //Extra options
  const doorExtraOptions = product.extraOptionsNames;
  // Extra options prices
  const doorExtraOptionsPrices = product.extraOptionsPrices;

  // Conditions to show extras
  const showDoorExtraOptionsPrices =
    doorExtraOptionsPrices && doorExtraOptionsPrices.length > 0;
  const showDoorExtraOptions = doorExtraOptions && doorExtraOptions.length > 0;
  return (
    <div className={`gg-mt-3 gg-pr-5 gg-text-sm lg:gg-mt-0.5 ${className}`}>
      <section className="gg-grid gg-w-full gg-gap-y-1 sm:gg-gap-y-1.5 md:gg-gap-y-2">
        <div className="gg-grid gg-grid-cols-2">
          <Heading headingLevel="h6" className="gg-font-bold">
            Type
          </Heading>
          <Text className="gg-text-right lg:gg-text-start">
            {doorLayoutName}&nbsp;
            <span className="gg-ml-0.5 gg-text-xs gg-text-purple-300">
              ({doorLayoutPrice})
            </span>
          </Text>
        </div>

        <div className="gg-grid gg-grid-cols-2">
          <Heading headingLevel="h6" className="gg-font-bold">
            Kleur
          </Heading>
          <Text className="gg-text-right lg:gg-text-start">
            {doorColorName}&nbsp;
            <span className="gg-ml-0.5 gg-text-xs gg-text-purple-300">
              ({doorColorPrice})
            </span>
          </Text>
        </div>

        {showDoorExtraOptions && (
          <div className="gg-grid gg-grid-cols-2">
            <Heading headingLevel="h6" className="gg-font-bold">
              Extra opties
            </Heading>
            <ul className="gg-space-y-1 gg-text-right lg:gg-text-start">
              {doorExtraOptions.map((name, index) => (
                <li key={name}>
                  <Text>
                    {name}&nbsp;
                    <span className="gg-ml-0.5 gg-text-xs gg-text-purple-300">
                      (
                      {showDoorExtraOptionsPrices &&
                        "€" + doorExtraOptionsPrices[index].toFixed(2)}
                      )
                    </span>
                  </Text>
                </li>
              ))}
            </ul>
          </div>
        )}
      </section>
    </div>
  );
};
export default ProfielProductItemConfigTable;
